import { Field, ErrorMessage } from 'formik';
import RequiredAsterisk from 'components/Forms/RequiredAsterisk';
import Label from 'components/Forms/Label';

const SponsoredBrandCampaign = ({ handleChange }) => {
  const adFormats = [
    { name: 'Product Collection ', value: 'productCollection' },
    { name: 'Video', value: 'video' },
  ];

  return (
    <div className="flex flex-col w-full gap-y-6 p-8 md:pb-8 md:px-0 md:pt-0 overflow-y-auto">
      <div>
        <Label
          htmlFor="data.campaignName"
          classes="text-left leading-1.2"
          textColor="text-grayscale-800"
          textSize="13"
        >
          Campaign Name <RequiredAsterisk />
        </Label>
        <Field
          name="data.campaignName"
          placeholder="Add campaign name"
          className="form-input text-13 text-grayscale-900 leading-1.5 bg-grayscale-400"
          type="text"
          onChange={(e) => {
            handleChange(e);
          }}
        />
        <ErrorMessage
          name="data.campaignName"
          component="div"
          className="text-red-700 font-normal text-xs"
        />
      </div>

      <div className="grid grid-cols-3 gap-4">
        <div>
          <Label
            classes="text-left leading-1.2"
            textColor="text-grayscale-800"
            textSize="13"
          >
            Start Date <RequiredAsterisk />
          </Label>
          <input
            name="data.startDate"
            type="date"
            placeholder="Select Date"
            className="form-select disabled-white text-13 text-grayscale-900 leading-1.5 bg-grayscale-400"
            onChange={(e) => {
              handleChange(e);
            }}
          ></input>
          <ErrorMessage
            name="data.startDate"
            component="div"
            className="text-red-700 font-normal text-xs"
          />
        </div>
        <div>
          <Label
            classes="text-left leading-1.2"
            textColor="text-grayscale-800"
            textSize="13"
          >
            End Date <RequiredAsterisk />
          </Label>
          <input
            name="data.endDate"
            type="date"
            placeholder="Select Date"
            className="form-select disabled-white text-13 text-grayscale-900 leading-1.5 bg-grayscale-400"
            onChange={(e) => {
              handleChange(e);
            }}
          ></input>
          <ErrorMessage
            name="data.endDate"
            component="div"
            className="text-red-700 font-normal text-xs"
          />
        </div>
        <div>
          <Label
            classes="text-left leading-1.2"
            textColor="text-grayscale-800"
            textSize="13"
          >
            Budget <RequiredAsterisk />
          </Label>
          <div className="flex justify-center gap-0 items-center">
            <span className="text-black sm:text-sm">$</span>
            <Field
              name="data.budget"
              className="form-input text-13 text-grayscale-900 leading-1.5 bg-grayscale-400 disabled-white"
              type="number"
              onChange={(e) => {
                handleChange(e);
              }}
            />
          </div>
          <ErrorMessage
            name="data.budget"
            component="div"
            className="text-red-700 font-normal text-xs"
          />
        </div>
      </div>

      <div>
        <Label
          htmlFor="data.adGroupName"
          classes="text-left leading-1.2"
          textColor="text-grayscale-800"
          textSize="13"
        >
          Ad Group Name <RequiredAsterisk />
        </Label>
        <Field
          name="data.adGroupName"
          placeholder="Add ad group name"
          className="form-input text-13 text-grayscale-900 leading-1.5 bg-grayscale-400"
          type="text"
          onChange={(e) => {
            handleChange(e);
          }}
        />
        <ErrorMessage
          name="data.adGroupName"
          component="div"
          className="text-red-700 font-normal text-xs"
        />
      </div>

      <div>
        <Label
          htmlFor="data.adFormat"
          classes="text-left leading-1.2"
          textColor="text-grayscale-800"
          textSize="13"
        >
          Ad Format <RequiredAsterisk />
        </Label>
        <Field
          name="data.adFormat"
          as="select"
          className="form-select disabled-white text-13 text-grayscale-900 leading-1.5 bg-grayscale-400"
          onChange={(e) => {
            handleChange(e);
          }}
        >
          {adFormats.map((b, i) => (
            <option key={`data.adFormat.${i}`} value={b.value}>
              {b.name}
            </option>
          ))}
        </Field>
      </div>

      <div>
        <Label
          htmlFor="data.negativeKeywords"
          classes="text-left leading-1.2"
          textColor="text-grayscale-800"
          textSize="13"
        >
          Negative Keyword Targeting
        </Label>
        <Field
          name="data.negativeKeywords"
          placeholder="Add negative keywords"
          className="form-input text-13 text-grayscale-900 leading-1.5 bg-grayscale-400"
          type="text"
          onChange={(e) => {
            handleChange(e);
          }}
        />
      </div>
    </div>
  );
};

export default SponsoredBrandCampaign;
